import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=06c4cd5b&"
import script from "./Render.vue?vue&type=script&lang=js&"
export * from "./Render.vue?vue&type=script&lang=js&"
import style0 from "./Render.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Render.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports